import {
  Balance
} from 'helpers/models';

export const mapBalance = (result) => {
  return new Balance(result).mapToStandard();
};